import PREORDER_API from '@/api/preorder';
import _ from 'lodash';

// initial state
const state = () => ({
  preorder: null,
  result: null,
  cart: {},
});

// getters
const getters = {
  preorder: (state) => state.preorder,
  cart: (state) => state.cart[state.preorder.id] ?? {},
  result: (state) => state.result,
  itemMap: (state) => {
    const itemInfo = {};
    for (const category of state.preorder.categoryList) {
      for (const item of category.itemList) {
        let consumeCoin = 0;
        if (category.categoryType === 'NORMAL') {
          consumeCoin = category.normalConsumeCoin;
        } else if (category.categoryType === 'TREADING') {
          if (item.type === 'TREADING_SINGLE') {
            consumeCoin = category.treadingSingleConsumeCoin;
          } else if (item.type === 'TREADING_BOX') {
            consumeCoin = category.treadingBoxConsumeCoin;
          }
        }
        itemInfo[item.itemId] = {
          itemId: item.itemId,
          image: item.image,
          name: item.name,
          consumeCoin: consumeCoin,
          category: category.categoryType,
        };
      }
    }
    return itemInfo;
  },
  itemListInCart: (state, getters) => {
    if (Object.keys(state.cart).length === 0) return [];
    const list = [];
    for (const [itemId, itemCount] of Object.entries(getters.cart)) {
      list.push(Object.assign({}, getters.itemMap[itemId], { count: itemCount }));
    }
    list.sort((a, b) => Number.parseInt(a.itemId, 10) < Number.parseInt(b.itemId, 10) ? -1 : Number.parseInt(a.itemId, 10) > Number.parseInt(b.itemId, 10) ? 1 : 0);
    return list;
  },
  bonusItemListFromCart: (state, getters) => {
    const bonusItemList = [];
    for (const category of state.preorder.categoryList) {
      for (const bonus of category.bonusList) {
        const bonusItemCount = getters.cart[bonus.targetItemId] ?? 0;
        if (bonusItemCount > 0) {
          bonusItemList.push({
            name: bonus.item.name,
            image: bonus.item.image,
            count: bonusItemCount
          });
        }
      }
    }
    return bonusItemList;
  },
  itemCountOptions: () => {
    return Array.from({ length: 101 }, (_, index) => ({ label: `${index}`, value: index }));
  },
  totalItemCoin: (_, getters) => {
    return getters.itemListInCart.map((item) => item.count * parseInt(item.consumeCoin, 10)).reduce((sum, v) => sum + v, 0);
  },
};

// actions
const actions = {
  async realCart({ state }) {
    return JSON.parse(localStorage.getItem('pipmeyCart')).preorder.cart[state.preorder.id];
  },
  async isReplacedCart({ dispatch, getters }) {
    const cart = await dispatch('realCart');
    return !_.isEqual(getters.cart, cart);
  },
  async get({ state, commit, rootGetters }, id) {
    try {
      const res = await PREORDER_API.get(id);
      if (res.data) {
        res.data.id = id;
        commit('preorder', res.data);
      }
    } catch (e) {
      throw e;
    }
  },
  async reset({ state, commit }) {
    state.preorder = null;
    state.result = null;
    state.cart = {};
  },
  async refresh({ commit }) {
    commit('cart', JSON.parse(localStorage.getItem('pipmeyCart'))?.preorder?.cart);
  },
  async updateCart({ state, commit }, { itemId, itemCount }) {
    const newCart = { ...state.cart };
    if (itemCount > 0) {
      if (!newCart[state.preorder.id]) newCart[state.preorder.id] = {};
      newCart[state.preorder.id][itemId] = itemCount;
    } else {
      delete newCart[state.preorder.id][itemId];
    }
    commit('cart', newCart);
  },
  async purchase({ state, commit }, data) {
    try {
      const res = await PREORDER_API.purchase(data);
      if (res.data) {
        commit('result', res.data);
      }
    } catch (e) {
      throw e;
    }
  },
};

const mutations = {
  preorder(state, data) {
    state.preorder = data;
  },
  result(state, data) {
    state.result = data;
  },
  cart(state, data) {
    state.cart = data;
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
